export class EventTypeInputRating {
    constructor(
        eventTypeInputRatingId: number,
        eventTypeInputId: number,
        numberOfIcons: number,
        iconNumberText: string,
        commentMandatoryNumbers: string
    ) {
        this.eventTypeInputRatingId = eventTypeInputRatingId;
        this.eventTypeInputId = eventTypeInputId;
        this.numberOfIcons = numberOfIcons;
        this.iconNumberText = iconNumberText;
        this.commentMandatoryNumbers = commentMandatoryNumbers;
        this.commentMandatoryNumbersArray = [];
        this.setCommentMandatoryNumbersArray(commentMandatoryNumbers);
    }

    eventTypeInputRatingId: number;
    eventTypeInputId: number;
    numberOfIcons: number;
    iconNumberText: string;
    commentMandatoryNumbers: string;
    commentMandatoryNumbersArray: number[];

    setCommentMandatoryNumbersArray(numbersStr: string) {
        const splitted = numbersStr.split(',').map((o) => Number(o));
        if (splitted) {
            this.commentMandatoryNumbersArray = splitted;
        } else {
            this.commentMandatoryNumbersArray = [];
        }
    }
}
